import React from 'react';

import './ExpandedRow.css';
import ScoreRadio from '../../../components/UI/RadioButton/RadioButton';
import { regretReason } from '../../../shared/constants';
import moment from 'moment';

import Tabs from '../../UI/Tabs/Tabs';
import Tab from '../../UI/Tab/Tab';
import FeedbackHistory from '../../Common/FeedbackHistory/FeedbackHistory';

/**
* @desc Actual scoring part 
* @param props
* @return whole scoring part
*/
const Scoring = (props) => {
  return (
    <div className="scoring">
    {props.scoring.map((score, index) => (      
      <Score 
        key={index} 
        {...score} 
        handleScoreChange={props.handleScoreChange} 
        radioDisable={props.radioDisable}
      />
    ))}
    </div>
  );
}
const scoreMax = 5;

/**
* @desc radio button for adding score
* @param props
* @return score depending on the condition checked or unchecked
*/
const Score = (props) => {
  return (
    <div className="score-item">
      <div className="score-name">{props.name}</div>
      <div className="score">
        {[...Array(scoreMax)].map((score, index) => (
          <div className="option" key={index}>
            <div className="value">{index+1}</div>
            <ScoreRadio 
              index={index+1} 
              id={props.id} 
              value={props.value} 
              handleScoreChange={props.handleScoreChange} 
              radioDisable={props.radioDisable}
            />
            <div className="check-score"></div>
          </div>
        ))}
      </div>
    </div>
  );
}

const ExpandedRow= (props) =>{
  return (  
   <div className="report-scoring">
    <div className="scoring-top-line visible-xs-block"></div>

    <div className={(props.companyType===1) ? "scoring-total" : "scoring-total feedback-score " + props.candidateStatus.toLowerCase() + "-wrapper" }>     
      <div className="candidate-status-section">
        {props.companyType===1?
          <div className="scroing-value">
          Total: <span>{props.scoreValue}</span>
          </div>:""
        }
        <span className="candidate-status-icon">
          <div className={props.candidateStatus.toLowerCase() + "-icon"}></div> 
        </span>  
        {props.companyType!==1 ?
          <div className="candidate-status-content">
            { props.candidateStatus.toLowerCase()=="regret"?
              "Candidate has been regretted"
              :"Candidate has been progressed"}
          </div>
          :""
        }      
        {props.candidateStatus.toLowerCase()=="regret" ? 
          <span className="candidate-regret-content">Reason for Regret:
            <div className="candidate-regret-reason">{(regretReason[props.regretReason])}</div>
          </span>:""
        }
      </div> 
      
      <div className="candidate-scored-by">
        <div className="candidate-submittedby">
          <div className="candidate-sub-by">Submitted by: </div>
          <div className="candidate-scored-name">{props.scoredBy}</div>
        </div>
        <div className="candidate-submitted-date">
          {props.companyType!==1 ?<span className="candidate-scored-date">{moment(props.sortedDate).format("dddd, DD MMMM | h:mm a")}</span>:""}
        </div>
      </div>             
    </div> 
    {props.companyType===1?           
    <div className="scoring-data">
      <h1 className="profile-scoring-title visible-xs-block">Interview Scoring</h1>
      <div className="profile-scoring-title hidden-xs">
        <h1>Interview Scoring</h1>
        <div className="value">1</div>
        <div className="value">2</div>
        <div className="value">3</div>
        <div className="value">4</div>
        <div className="value">5</div>
      </div>
      {props.scoringData !== ""?
        <Scoring 
          scoring={props.scoringData}
          radioDisable={'disabled'}
        />:""}
      </div>: (props.clientFeedback || props.feedbackHistory.length > 0)?
        <div className="client-feedback">
          <Tabs>
            <Tab label="Client Evaluation" tabKey={1} onClickHandler={()=>null}>
              <div className="client-evaluation">
                <div className="client-feedback-text">
                  {(props.clientFeedback) ? props.clientFeedback : null}
                </div>
              </div>
            </Tab>
            <Tab label="Evaluation History" tabKey={2} onClickHandler={()=>null}>
              <FeedbackHistory feedbackHistory={props.feedbackHistory} />
            </Tab>
          </Tabs>
        </div>
      :""
    }
    </div>
);
}

export default ExpandedRow;


// WEBPACK FOOTER //
// ./src/components/Recruiter/ExpandedRow/ExpandedRow.js